import { Label } from '@radix-ui/react-label'
import { FC, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { sendMessage } from 'features/firebase/contact-us'
import { useAuthStore } from 'features/user/auth-store'

import { GreenButton } from 'shared/components'
import { Card, CardContent, CardHeader, CardTitle } from 'shared/components/ui/card'
import { Textarea } from 'shared/components/ui/textarea'
import { useBoolean } from 'shared/hooks/use-boolean'

export const ContactUs: FC = () => {
  const { user } = useAuthStore()
  const navigate = useNavigate()
  const [message, setMessage] = useState('')
  const [thanks, toggleThanks] = useBoolean()

  const handleSendMessage = () => {
    if (!user) return

    sendMessage(message, user.uid)
    toggleThanks(true)
  }

  return (
    <Card className="mx-auto my-10 flex w-11/12 flex-col items-center justify-center gap-2 p-2 sm:gap-6 lg:w-[800px]">
      <CardHeader>
        <CardTitle>Contact Us</CardTitle>
      </CardHeader>
      <CardContent className="space-y-5 leading-relaxed">
        We value your feedback and are always eager to hear from our players.
        <br />
        Whether you have suggestions, questions, or just want to share your thoughts,
        <br />
        please feel free to reach out to us.
        <br />
        Your input helps us improve and create a better gaming experience for everyone.
        <div className="mt-3 w-full">
          <Label htmlFor="message" className="text-sm">
            Your message
          </Label>
          <Textarea
            value={message}
            onChange={e => setMessage(e.target.value)}
            id="message"
            placeholder="Type your message here."
          />
        </div>
        {thanks ? (
          'Message has been sent.'
        ) : user ? (
          <GreenButton text="Send" className="w-full" onClick={handleSendMessage} disabled={!message.trim()} />
        ) : (
          <GreenButton text="Login" className="w-full" onClick={() => navigate('/login')} />
        )}
      </CardContent>
    </Card>
  )
}
